
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gjvJrJin2gJqYsLFFAv3JfFuzQmCTWNzCuTGXsiolTo0Meta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index9c0URVOKf0IgXq3pjo5wh1khgKU4lAS_45jnNhUJITTLIMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchhqu4y_nGIve3gAiNnMZHwnNo3_4E63_45jg_zzlwb3gTwMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexzb_e4LhLExR_T3QPwyViV0Hjb_bGbX3IKErMVX9T7ekMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ihs1qZM_45Zv0uCery7LvOBW7ARdZ2l64zgrtRIKPZOmUMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHlAD6VbYpGRkNsraNCWg6P6f8l_45zHlhNf5su5H6fSkQMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93USjxbg4GaZ2Kr_454YkWo6zmnteaFPCt_45izaam8n29p4gMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexJElYj40vS5GubdrbCjExHe5PT5hBMn8YAPVA48bBx2AMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93LJ7MJMoymnyG9P7MeJ8X3nC86tbgDWSuTs_lqMXZPEoMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexHjmuJ3y3CZMzVHcRN4RQGUxnzKDpu0aJUOt9W2fex50Meta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexC_wZNfCAU6rArz5L14lAIZWj__45uXwC7rbUXEXz_45Ob7wMeta } from "/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHlAD6VbYpGRkNsraNCWg6P6f8l_45zHlhNf5su5H6fSkQMeta || {},
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexJElYj40vS5GubdrbCjExHe5PT5hBMn8YAPVA48bBx2AMeta || {},
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexHjmuJ3y3CZMzVHcRN4RQGUxnzKDpu0aJUOt9W2fex50Meta || {},
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexC_wZNfCAU6rArz5L14lAIZWj__45uXwC7rbUXEXz_45Ob7wMeta || {},
    component: () => import("/codebuild/output/src301331255/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]